export interface SectionDropdownActionType {
  type: SectionDropdown;
  payload?: any;
}

export enum SectionDropdown {
  GET_SECTION_DROPDOWN_LIST = "GET_SECTION_DROPDOWN_LIST",
  SET_SECTION_DROPDOWN_LIST = "SET_SECTION_DROPDOWN_LIST",
  SET_SECTION_DROPDOWN_ID = "SET_SECTION_DROPDOWN_ID",
  SET_SECTION_DROPDOWN_LOADING = "SET_SECTION_DROPDOWN_LOADING",
}
